<style lang="stylus">
    .order-count {

    }
</style>
<style scoped lang="stylus">
    .order-count {
        padding 0 6px
        .van-collapse {
            &:after {
                border none
            }
        }
        .value {
            text-align center
            span {
                font-size: 14px
            }
            .weight {
                border 1px solid #14AFD8
                color: #14AFD8
                padding 3px 8px
                margin-right: 8px
            }
            .money {
                color: #80DCBB
                margin 0
            }
        }
        .van-cell-group {
            &:after {
                border: none
            }
            .van-cell {
                background-color: #162130
                &:after {
                    /*border-color: #454545*/
                    border none
                }
            }

            .van-cell__title {
                color: #fff
            }
            .van-cell__value {
                flex: none
            }
            .van-cell {
                padding: 10px
            }
        }
    }
</style>

<template>
    <div class="order-count cus-cell">
        <QuickTime @time-change="kTimeChange" :is-quick-time="isQuickTime"/>

        <van-cell :title="timeTips" class="time-tips no_border"/>

        <div v-show="loading" style="height: 100%;">
            <van-loading vertical>加载中...</van-loading>
        </div>
        <van-cell-group v-if="!loading && list.length">
            <template v-for="(item, index) in list">
                <van-cell :title="item.factory_name">
                    <div slot="default" class="value">
                        <span class="weight">{{item.total_weight}}吨</span>
                        <span class="money">{{item.total_money}}元</span>
                    </div>
                </van-cell>
                <CountChart :data="item.stone" />
            </template>
        </van-cell-group>

        <CountFilter ref="countFilter" @filter-change="filterChange" :isFactory="isFactory"/>
    </div>
</template>

<script>
    import _ from 'lodash'
    import {getCount} from "@/service/order";
    import CountFilter from './components/CountFilter'
    import QuickTime from '@/components/QuickTime'
    import CountChart from './components/CountChart'
    import {mapState} from "vuex";

    export default {
        props: [],
        components: {
            CountFilter,
            QuickTime,
            CountChart,
        },
        data() {
            return {
                activeNames: [],
                loading: false,
                list: [],

                searchForm: {
                    settlement_time: '',
                    factory_id: '',
                },
                isQuickTime: true,
                dayType: '',
            };
        },
        created() {
            // this.getData()
        },
        mounted() {
            this.$eventHub.$on('click-right', () => {
                this.$refs.countFilter.show(this.isQuickTime)
            })
        },
        computed: {
            ...mapState({
                factoryId: state => state.userInfo.factory_id
            }),
            isFactory() {
                return this.factoryId > 0
            },
            searchTimeList() {
                return this.searchForm.settlement_time.split(' - ')
            },
            timeTips() {
                return this.isQuickTime && this.dayType == 'day' ? `${this.searchTimeList[0]} - 目前` : this.searchForm.settlement_time
            },
        },
        watch: {},
        methods: {

            getData() {
                this.getList()
            },
            async getList() {
                let formData = _.assign({}, this.searchForm)
                if (this.isFactory) formData.factory_id = this.factoryId
                this.startLoading()
                let res = await getCount(formData)
                this.stopLoading()
                if (res.status) {
                    this.list = this.handleData(res.data)
                } else {
                    this.$toast(res.info)
                }
            },
            startLoading() {
                this.loading = true
            },
            stopLoading() {
                this.loading = false
            },
            handleData(data) {
                let res = []
                data.map(item => {
                    res.push({
                        factory_name: item.factory_name,
                        total_money: item.total.total_money.toFixed(2),
                        total_num: item.total.total_num,
                        total_weight: item.total.total_weight.toFixed(2),
                        stone: item.stone
                    })
                })
                return res
            },

            search() {
                this.activeNames = []
                this.list = []
                this.getList()
            },
            kTimeChange({time, type}) {
                this.dayType = type
                this.isQuickTime = true
                this.searchForm.settlement_time = time
                this.search()
            },
            filterChange(searchForm) {
                if (searchForm.settlement_time) {
                    this.isQuickTime = false
                    this.searchForm = searchForm
                } else {
                    this.searchForm = Object.assign({}, this.searchForm, _.omit(searchForm, ['settlement_time']))
                }
                this.search()
            },
        },
        destroyed() {
            this.$eventHub.$off()
        },
    };
</script>
